import { NQError } from "@visonum/network-quality-sdk";
import { NQInternalError } from "@visonum/network-quality-sdk/dist/src/main/NQError";
import createKey from "./createKey";
import getTagsForNqError from "./getTagsForNqError";
import getTagsForNqInternalError from "./getTagsForNqInternalError";
import SentryTags from "../../features/sentryReports/SentryTags";

const formatString = (value: string): string => {
    return value.replaceAll(/[\n\r]/g, ' ');
}

export const getCauseTags = (cause: Error, prefix: string): SentryTags => {
    if (cause instanceof NQError) {
        return getTagsForNqError(cause, prefix);
    }

    if (cause instanceof NQInternalError) {
        return getTagsForNqInternalError(cause, prefix);
    }

    const result: SentryTags = {}
    result[createKey("Error", prefix)] = formatString(JSON.stringify(cause));
    return result;
}

export default getCauseTags;